import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "./ProductComponentStyle.css";
import Modal from "react-bootstrap/Modal";
import ProductList from "../../pages/Product/ProductList";
import SimilarProductsArrayComponent from "./SimilarProductsArrayComponent";
import "../Glass/ProcureModalStyle.css";
import "../Glass/GlassStyle.css";

/**
 * SimilarProductsModal component.
 *
 * @param {Object} props - The props object
 * @param {Array} props.similarProducts - The array of similar products
 * @param {Function} props.setSimilarProducts - The function for setting the similar products
 *
 * @returns {jsx} - The rendered JSX
 */
const SimilarProductsModal = ({ similarProducts, setSimilarProducts }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShowModal = () => {
    setShow(true);
  };

  return (
    <>
      <Button variant="outline-success" onClick={handleShowModal} className="mb-3">
        Select Competing Products
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        fullscreen={true}
        dialogClassName="procure-modal-glass procure-modal-glass-product"
      >
        <Modal.Header closeButton className="procure-modal__header">
          <Modal.Title>Competing Products</Modal.Title>
        </Modal.Header>
        <Modal.Body className="procure-modal__body">
          <SimilarProductsArrayComponent
            similarProductsArray={similarProducts}
            setSimilarProductsArray={setSimilarProducts}
          />
          <ProductList
            similarProductsView={true}
            similarProducts={similarProducts}
            setSimilarProducts={setSimilarProducts}
          />
        </Modal.Body>
        <Modal.Footer className="procure-modal__footer">
          <Button
            variant="primary"
            className="glass-primary-btn"
            disabled={!similarProducts.length}
            onClick={handleClose}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SimilarProductsModal;
